import { useState } from 'react'

import SetState from 'Components/Hooks/SetState'
import ButtonInsideBox from 'Components/UI/Atoms/ButtonInsideBox'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import Children from 'Components/UI/Organisms/Settings/Various/Engine/Children'
import { getNavbar } from 'service/helpers/localstorage'

const Engine = () => {
  const { state: dialogState, setOpen, setClose } = SetState()

  const [canClose, setCanClose] = useState(true)
  const createDismissableSnackbar = useCustomSnackbar()

  function handleClose() {
    if (canClose === true) {
      setClose()
    } else {
      createDismissableSnackbar('Tiene cambios sin guardar!', {
        variant: 'error',
      })
    }
  }

  return (
    <>
      <ButtonInsideBox
        onClick={setOpen}
        text="Motores"
        button="Configurar"
        img={process.env.PUBLIC_URL + '/Images/engine.webp'}
        disabled={JSON.parse(getNavbar()).engines ? false : true}
      />
      <DialogComponent
        disableBackdropClick
        disableEscapeKeyDown
        widthLarge="70vw"
        title="Motores"
        open={dialogState.open}
        handleclose={handleClose}
        maxHeight
        children={<Children canClose={canClose} setCanClose={setCanClose} />}
      />
    </>
  )
}

export default Engine
